export enum LoadingPlanStatus {
    New = 1,
    InProcess = 2,
    Processed = 3,
}

export const enumLabel = (value?: LoadingPlanStatus) => {
    switch (value) {
        case LoadingPlanStatus.New:
            return 'Новый';
        case LoadingPlanStatus.InProcess:
            return 'В работе';
        case LoadingPlanStatus.Processed:
            return 'Обработан';
        default:
            return '';
    }
};
